import { Pipe, PipeTransform } from '@angular/core';
import { GENDER, IShareUser, IUser } from '../../@core/models/model';
import { environment } from '../../../environments/environment.dev';

@Pipe({
    standalone: true,
    name: 'userAvatar'
})

export class UserAvatarPipe implements PipeTransform {
    transform(user: Partial<IUser> | null | undefined | IShareUser | string): string {
        if (!user) {
            return randomAvatarGenerator(0);
        }
        if ((user as IUser).profileUrl) {
            return `${environment.s3Url}/${(user as IUser).profileUrl}?timestamp=${new Date().getTime()}`;
        }
        if ((user as IUser).profilePicture?.url) {
            return `${environment.s3Url}/${(user as IUser).profilePicture.url}?timestamp=${new Date().getTime()}`;
        }
        let randomAvatar = randomAvatarGenerator((user as IUser)?.gender || 0, (user as IUser)?._id || (user as IUser)?.email);
        return randomAvatar;
    }
}

const avatarCache = new Map<string, number>();
const men = [3, 5, 6, 7, 8, 11, 12, 13, 16, 18, 20, 23, 24, 27];
const women = [1, 2, 4, 9, 10, 14, 15, 17, 19, 21, 22, 25, 26];

function simpleHash(str: string, gender: GENDER | 0): number {
    if (avatarCache.has(str)) {
        return avatarCache.get(str)!;
    }

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    const res = Math.abs(hash);
    let index: number;
    if (gender == 0) {
        index = res % 9 + 1;
    } else {
        const avatarArray = gender === GENDER.MALE ? men : women;
        index = res % avatarArray.length;
    }
    avatarCache.set(str, index);
    return index;
}

export function randomAvatarGenerator(gender: GENDER | 0, userIdentifier: string = 'default') {
    let avatarUrl: string;
    if (gender === 0) {
        const index = simpleHash(userIdentifier, gender);
        avatarUrl = `${environment.s3Url}/arena-ai/public-assets/avatars/external_${index}.png`;
    } else {
        const index = simpleHash(userIdentifier, gender);
        const avatarArray = gender === GENDER.MALE ? men : women;
        avatarUrl = `https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_${avatarArray[index]}.png`;
    }
    return avatarUrl;
}
